import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';

import { locationReducer, routerMiddleware, routerEnhancer } from 'routes';
import uiReducer from 'ducks/ui';
import toastsReducer from 'ducks/toasts';
import postsReducer from 'ducks/posts';



const rootReducer = combineReducers({
	location: locationReducer,
	ui: uiReducer,
	toasts: toastsReducer,
	posts: postsReducer
});

const enhancer = compose(
	routerEnhancer,
	applyMiddleware(routerMiddleware, ReduxThunk),
	// applyMiddleware(ReduxThunk.withExtraArgument(api)),
	window.devToolsExtension ? window.devToolsExtension() : f => f
);


// Initial state (if there is no preloaded state) is empty,
// and each reducer produces its own default state.
const initialState = {};
// Grab the state from a global variable injected into the server-generated HTML (from react-snap)
const preloadedState = window.__PRELOADED_STATE__;
// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__


const store = createStore(
	rootReducer,
	preloadedState || initialState,
	enhancer
);

export default store;


// Tell react-snap how to save Redux state
window.snapSaveState = () => ({
  '__PRELOADED_STATE__': store.getState()
});



// WEBPACK FOOTER //
// ./src/store.js